import { fetchQuery, graphql } from "relay-runtime"
import { insureeDataFromSasisByInsureeNumberQuery } from "@/modules/admin/sasis-lookup/services/__generated__/insureeDataFromSasisByInsureeNumberQuery.graphql"
import { InsureeDataFromSasis } from "@/modules/admin/sasis-lookup/services/insureeDataFromSasisByHealthInsuranceCardNumberQuery"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query insureeDataFromSasisByInsureeNumberQuery($nationalInsuranceNumber: Int!, $insureeNumber: String!) {
    ch_insureeDataFromSasisByInsureeNumber(
      nationalInsuranceNumber: $nationalInsuranceNumber
      insureeNumber: $insureeNumber
    ) {
      mapped {
        firstName
        lastName
        dateOfBirth
        gender
        insureeNumber
        insuranceCardNumber
        socialSecurityNumber
        healthInsurance
        nationalInsuranceNumber
        isPrimary
        gatekeeperZsr
        validFrom
        validTo
        address {
          houseNumberStreet
          city
          postalCode
          countryCode
        }
      }
      rawXml
      returnCode
      returnMessage
    }
  }
`

export const fetchInsureeDataFromSasisByInsureeNumber = (
  nationalInsuranceNumber: number,
  insureeNumber: string,
): Promise<InsureeDataFromSasis | null> =>
  fetchQuery<insureeDataFromSasisByInsureeNumberQuery>(
    RelayEnvironment,
    query,
    { nationalInsuranceNumber, insureeNumber },
    { fetchPolicy: "network-only" },
  )
    .toPromise()
    .then((response) => response?.ch_insureeDataFromSasisByInsureeNumber ?? null)
